import { useEffect, useState } from 'react';
import client from '../../../../utils/apolloClient';
import { fetchCompanyQuery } from '../services/companySummaryQueries';

export function useFetchCompany(companyId, refreshKey) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!companyId) {
      setData(null);
      return;
    }
    setLoading(true);
    setError(null);
    client.clientPrivate
      .query({
        query: fetchCompanyQuery,
        variables: { companyId },
        fetchPolicy: 'network-only',
      })
      .then(({ data: res }) => {
        setData(res?.fetch_company ?? null);
        setLoading(false);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
      });
  }, [companyId, refreshKey]);

  return { data, loading, error };
}
